import axios from "axios";
import { axiosPrivate } from "../api/axiosCore";

export const serviceSubmitBlockRequest = async (token, data, evidenceFile) => {
  try {
    const bodyFormData = new FormData();
    for (const key in data) {
      if (data[key] !== undefined && data[key] !== null) {
        bodyFormData.append(key, data[key]);
      }
    }
    bodyFormData.append("evidence", evidenceFile);

    const resp = await axios.post(
      process.env.REACT_APP_BASE_URL + "api/contact-block-requests",
      bodyFormData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return resp;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceGetBlockRequests = async (token, params = {}) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const query = new URLSearchParams(params).toString();
    const resp = await axiosPrivate.get(
      "api/contact-block-requests" + (query ? "?" + query : ""),
    );

    return resp;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceApproveBlockRequest = async (token, id) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const resp = await axiosPrivate.put(
      "api/contact-block-requests/" + id + "/approve",
    );

    return resp;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceUnblockRequest = async (token, id) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const resp = await axiosPrivate.put(
      "api/contact-block-requests/" + id + "/unblock",
    );

    return resp;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceCheckBlockedBulk = async (token, phoneNumbers) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
      return config;
    });

    const resp = await axiosPrivate.post(
      "api/contact-block-requests/check-bulk",
      { phoneNumbers },
    );

    return resp;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceCheckPendingBulk = async (token, phoneNumbers) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
      return config;
    });

    const resp = await axiosPrivate.post(
      "api/contact-block-requests/check-pending-bulk",
      { phoneNumbers },
    );

    return resp;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceRejectBlockRequest = async (token, id, rejectionReason) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
      return config;
    });

    const resp = await axiosPrivate.put(
      "api/contact-block-requests/" + id + "/reject",
      { rejectionReason },
    );

    return resp;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};
